/* eslint-disable react/prop-types */
import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  SomaIcon,
  SomaDescription,
  SomaCaption,
  SomaParagraph,
  SomaButton,
} from '@soma/react';

import useCurrentNotification from 'store/Notification/state';

import { useNotificationContext } from '../../../../state/notification';

// import pages from './pages';
import * as s from './styles';

const Item = ({ item }) => {
  const { getCurrentNotification } = useCurrentNotification();

  const [state, dispatch] = useNotificationContext();
  const { current } = state;
  const { id, loading } = current;

  const history = useHistory();
  const getActionButton = (type, name, action, externalId) => {
    switch (type.toLowerCase()) {
      case 'download':
        return (
          <SomaButton
            key={`${externalId} - ${type}`}
            loading={id === externalId && loading}
            icon="download"
            size="sm"
            variant="secondary"
            onSomaClick={
              () => getCurrentNotification({
                externalId,
                history,
                type: type.toLowerCase(),
              })}
          >
            {name}
          </SomaButton>
        );
      case 'redirect':
        return (
          <SomaButton
            key={`${externalId} - ${type}`}
            loading={id === externalId && loading}
            size="sm"
            variant="primary"
            onSomaClick={
              () => getCurrentNotification({
                externalId,
                history,
                type: type.toLowerCase(),
                action,
              })}
          >
            {name}
          </SomaButton>
        );
      default:
        return <></>;
    }
  };

  const getColor = (color) => {
    switch (color) {
      case 'red':
        return '#CC3333';
      case 'green':
        return '#4CAF50';
      case 'result':
        return '#E91E63';
      default:
        return '';
    }
  };

  return (
    <s.Container isReaded={item.isReaded}>
      <s.Header>
        <div className="title">
          <SomaIcon size="md" icon="flag" color={getColor(item.type)} />
          <SomaDescription>{item.title}</SomaDescription>
        </div>
        <div className="date">
          {item.alreadyRead
            ? (
              <SomaIcon icon="circle-status-fill" size="md" color="#E0AD00" />
            ) : (
              <SomaCaption>
                {moment(item.creationDateTime).tz('America/Sao_Paulo').startOf('hour').fromNow()}
              </SomaCaption>
            )}
        </div>
      </s.Header>
      <s.Content>
        <SomaParagraph variant="paragraph">{item.content}</SomaParagraph>
      </s.Content>
      {item.action?.map(value => getActionButton(value.type, value.name, value.redirectFor, item.externalId))}
    </s.Container>
  );
};

Item.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string,
    alreadyRead: PropTypes.bool,
    creationDateTime: PropTypes.string,
    content: PropTypes.string,
    title: PropTypes.string,
    action: PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
      redirectFor: PropTypes.string,
    }),
    externalId: PropTypes.string,
  }),
};

Item.defaultProps = {
  item: {},
};

export default Item;
